export default "__VITE_ASSET__BFqlcQCo__"